import {useLocalStorage} from 'react-use';

export const STAFF_SLUG_KEY = '@blesk/staffId';

export const useStaffId = () => {
  const [staffId] = useLocalStorage<string>(STAFF_SLUG_KEY);
  return staffId;
};
